import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import { EdiExportDownloadResponse } from 'src/types/edi';
import axiosInstance from 'src/utils/axios';

const useExportPOTimingLogsApi = () => {
  const call = useCallback(
    () => axiosInstance.get<EdiExportDownloadResponse>(api.exportPOTimingLogs),
    []
  );
  const { execute, isLoading } = useAsync(call, false);

  return { exportExecute: execute, exportLoading: isLoading };
};

export default useExportPOTimingLogsApi;
